import { Component, OnInit } from '@angular/core';
import {Subject} from 'rxjs';

@Component({
  selector: 'app-course-bidding',
  templateUrl: './course-bidding.component.html',
  styleUrls: ['./course-bidding.component.css']
})
export class CourseBiddingComponent implements OnInit {

  courses;
  errorMessage = 'You do not have any courses yet. You will be informed about it.';
  dtTrigger: Subject<string> = new Subject();
  dtOptions: DataTables.Settings = {};

  constructor() { }

  ngOnInit() {
    this.dtOptions = {
      paging: true,
      retrieve: true,
      destroy: true,
      lengthChange: true,
      info: false
    };
  }
}
